import { createSlice } from '@reduxjs/toolkit';
import isEqual from 'lodash/isEqual';
import * as AllActions from '../action';
import ActionType from '../actionType';
import {
  makeFetchFailedActionType,
  makeFetchSuccessActionType,
} from '../../event/fetchActionTypeProvider';
import { SingleTabType } from '../../utils/constant';
import { HttpStatusCode } from '../../fetch/core/constant';
import { NoSignalInterSectionStatus } from '../type';
import { isEmpty } from '@/utils';
const initialState: any = {
  alarmEventList: null,
  vehicleRealTimeInfo: {
    systemState: null,
    vehicleState: null,
    scheduleState: null,
    power: null,
    speed: null,
    takeOverUsername: null,
    issueNo: null,
    schedule: {
      scheduleNo: null,
      finishedMileage: null,
    },
    isSpeedLimitEnabled: null,
    taskType: null,
    mapVariableRemark: null,
  },
  vehicleBasicInfoNew: {
    vehicleName: null,
    businessType: null,
    vehicleVersion: null,
    cityName: null,
    stationName: null,
    stationUser: null,
    stationUserPhone: null,
    stationUseCase: null,
  },
  scheduleRealTime: {
    scheduleNo: null,
    goalIndex: null,
    finishedMileage: null,
    stopList: [],
  },
  takeoverIssueData: {
    issueNo: null,
    issueState: null,
    takeOverUser: null,
    vehicleName: null,
    takeOverSource: null,
    initFlag: false, // 初始化标志位
  },
  trafficLightData: {
    passLightAvailable: null,
    trafficLightIdList: [],
  },
  noSignalIntersectionData: {
    status: NoSignalInterSectionStatus.NONE,
    recordTime: '',
    groupLaneIdList: [],
  },
  pncTaskType: null,
  tabType: SingleTabType.DRIVABLE,
  exceptionData: {
    vehicleName: null,
    list: [],
  },
  operationData: {
    vehicleName: null,
    list: [],
  },
  vehicleRealTimePosition: null, // 车辆实时位置
  singleVehiclePosition: {
    timeStamp: 0,
    data: {},
  },
  mapScheduleUpdate: {
    timeStamp: 0,
  },
  accidentList: [],
  gpsSignal: null,
  sceneSignal: null,
};

let firstLoad = true;
const singleVehicleState = createSlice({
  name: 'singleVehicle',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AllActions.actionSingTabType, (state, action: any) => {
        state.tabType = action.payload;
      })
      .addCase(
        makeFetchSuccessActionType(ActionType.MONITOR_VEHICLE_BASE_INFO),
        (state, action: any) => {
          const resp = action.payload;
          state.vehicleBasicInfoNew = resp.data;
        }
      )
      .addCase(
        makeFetchFailedActionType(ActionType.MONITOR_VEHICLE_BASE_INFO),
        (state, action: any) => {
          state.vehicleBasicInfoNew = {};
        }
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.SINGLE_VEHICLE),
        (state, action: any) => {
          const response = action.payload;
          // 第一次返回立即渲染，之后用缓冲数据更新
          const { alarmEventList, ...otherData } = response.data || {};
          state.vehicleRealTimeInfo = otherData;
          if (!isEmpty(alarmEventList)) {
            state.alarmEventList = alarmEventList;
          }
        }
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.SINGLE_VEHICLE_ALARM),
        (state, action: any) => {
          const res = action.payload;
          state.alarmEventList = res?.data?.alarmEventList || [];
        }
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.SINGLE_VEHICLE_SCHEDULE),
        (state, action: any) => {
          const response = action.payload;
          state.scheduleRealTime = response.data || {};
        }
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.SINGLE_VEHICLE_EXCEPTION),
        (state, action: any) => {
          const response = action.payload;
          state.exceptionData = response.data;
        }
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.SINGLE_VEHICLE_OPERATION),
        (state, action: any) => {
          const response = action.payload;
          state.operationData = response.data;
        }
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.SINGLE_VEHICLE_TAKEOVER_ISSUE),
        (state, action: any) => {
          const response = action.payload;
          state.takeoverIssueData = { ...response.data, initFlag: true };
        }
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.SINGLE_VEHICLE_TRAFFIC_LIGHT),
        (state, action: any) => {
          const response = action.payload;
          state.trafficLightData = {
            passLightAvailable:
              response.data && response.data.passLightAvailable,
            trafficLightIdList:
              response.data && response.data.trafficLightIdList,
          };
          state.pncTaskType = response.data && response.data.pncTaskType;
        }
      )
      .addCase(
        makeFetchSuccessActionType(
          ActionType.SINGLE_VEHICLE_NO_SIGNAL_INTERSECTION
        ),
        (state, action: any) => {
          const response = action.payload;
          if (response.data) {
            state.noSignalIntersectionData = {
              status: response.data.status,
              recordTime: response.data.recordTime,
              groupLaneIdList: response.data.groupLaneIdList,
            };
          }
        }
      )
      .addCase(
        makeFetchSuccessActionType(
          ActionType.VEHICLE_MAP_UPDATE_SCHEDULE_POSITION
        ),
        (state, action: any) => {
          const res = action.payload;
          state.vehicleRealTimePosition = {
            lat: res.lat,
            lon: res.lon,
          };
        }
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.MAP_VEHICLE_POSITION_REQUEST),
        (state, action: any) => {
          const res = action.payload;
          if (res.code === HttpStatusCode.Success) {
            state.singleVehiclePosition.timeStamp = Date.now();
            state.singleVehiclePosition.data = res.data || {};
          }
        }
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.MAP_VEHICLE_SCHEDULE_UPDATE),
        (state, action: any) => {
          const res = action.payload;
          if (res.code === HttpStatusCode.Success) {
            state.mapScheduleUpdate.timeStamp = Date.now();
          }
        }
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.SINGLE_VEHICLE_ACCIDENT),
        (state, action: any) => {
          const res = action.payload;
          if (res.code === HttpStatusCode.Success) {
            state.accidentList = res?.data?.list;
          }
        }
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.SINGLE_VEHICLE_GPS),
        (state, action: any) => {
          const res = action.payload;
          if (res.code === HttpStatusCode.Success) {
            const { gpsSignal, sceneSignal } = res?.data || {};
            state.gpsSignal = gpsSignal;
            if (typeof sceneSignal == 'number') {
              state.sceneSignal = Number(
                sceneSignal.toString().match(/^\d+(?:\.\d{0,2})?/)
              );
            } else {
              state.sceneSignal = null;
            }
          }
        }
      );
  },
});

export default singleVehicleState.reducer;
